import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueObserveVisibility from 'vue-observe-visibility';

import { colors } from '@/constants/theme/colors';

Vue.use(VueObserveVisibility);
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.secondary
      }
    }
  }
});
